export default {
  defaultProps: {
    startColor: 'gray.200',
    endColor: 'gray.100',
  },
  baseStyle: {
    rounded: 'sm',
  },
}
